<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<div class="modal-header">
  <h3 class="modal-title">Create a License Discount Code</h3>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12 m-b-md">
      <p>
        Group admins who enter this code in the IPSAT Store pay the price below
        for each license. Faith-based groups pay the faith-based price and
        values-based groups pay the values-based price. Prices are in the
        currency of the group's licensing partner.
      </p>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Discount Code</label>
      <input
        type="text"
        placeholder="LEGACY2027"
        class="form-control"
        [(ngModel)]="licenseDiscount.name"
      />
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Last Day Valid (optional)</label>
      <input type="date" class="form-control" [(ngModel)]="lastDayValid" />
      <small class="text-muted">Leave blank for no expiration</small>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Faith-Based Price per License</label>
      <input
        type="number"
        placeholder="30"
        class="form-control"
        [(ngModel)]="licenseDiscount.faithBasedPrice"
      />
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Values-Based Price per License</label>
      <input
        type="number"
        placeholder="40"
        class="form-control"
        [(ngModel)]="licenseDiscount.valuesBasedPrice"
      />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success" type="button" (click)="save()">
    Create Discount
  </button>
</div>
